import { createAction } from 'redux-actions'
import * as constants from './constants'

export const authenticate = createAction(constants.AUTHENTICATE)
export const authenticatePending = createAction(constants.AUTHENTICATE_PENDING)
export const authenticateSuccess = createAction(constants.AUTHENTICATE_SUCCESS)
export const authenticateFailure = createAction(constants.AUTHENTICATE_FAILURE)

export const connect = createAction(constants.CONNECT)
export const disconnect = createAction(constants.DISCONNECT)

export const joinChannel = createAction(constants.JOIN_CHANNEL)
export const joinChannelPending = createAction(constants.JOIN_CHANNEL_PENDING)
export const joinChannelSuccess = createAction(constants.JOIN_CHANNEL_SUCCESS)
export const joinChannelFailure = createAction(constants.JOIN_CHANNEL_FAILURE)

export const socketOpenEventReceived = createAction(constants.SOCKET_OPEN_EVENT_RECEIVED)
export const socketErrorEventReceived = createAction(constants.SOCKET_ERROR_EVENT_RECEIVED)
export const socketCloseEventReceived = createAction(constants.SOCKET_CLOSE_EVENT_RECEIVED)

export const socketReconnectAttemptQueued = createAction(constants.SOCKET_RECONNECT_ATTEMPT_QUEUED)
export const socketReconnectTimerTicked = createAction(constants.SOCKET_RECONNECT_TIMER_TICKED)

export const channelErrorEventReceived = createAction(constants.CHANNEL_ERROR_EVENT_RECEIVED)
export const channelCloseEventReceived = createAction(constants.CHANNEL_CLOSE_EVENT_RECEIVED)

export const leaveChannel = createAction(constants.LEAVE_CHANNEL)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/actions.js